export default __webpack_public_path__ + "static/media/kalahastiTemple9.6cad19fe.png";